var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Organizations',{attrs:{"step":_vm.step},on:{"clicked":_vm.updateStep,"goToStep":_vm.customStep,"organisations":_vm.setOrganisations}})}
var staticRenderFns = []

export { render, staticRenderFns }